import routeDefinitions from './routeDefinitions';


const studioProtectedPages = [
  routeDefinitions.studio,
  routeDefinitions.studioEarningsReport,
  routeDefinitions.studioEarningsReportDaily,
  routeDefinitions.studioEarningsTopPerformers,
  routeDefinitions.studioDashboard,
  routeDefinitions.studioRoster,
  routeDefinitions.studioSettings,
  routeDefinitions.studioAdmin,
  routeDefinitions.studioWelcome,
  routeDefinitions.studioRejected,
  routeDefinitions.studioVerification,
  routeDefinitions.studioPerformerIdentities,
  routeDefinitions.studioOnboardPerformerIdentity,
  routeDefinitions.studioOnboardPrivacy,
  routeDefinitions.studioOnboardConfirmation,
  routeDefinitions.studioEditPerformerProfile,
  routeDefinitions.studioPerformerProfile,
  routeDefinitions.studioProfileConfirmation,
  routeDefinitions.studioAddExistingPerformer,
  routeDefinitions.studioCashout,
];

export default studioProtectedPages;
